module.exports = __webpack_public_path__ + "static/social-media-d3089f8128383ee17fe43697af794cbb.jpg";